import { useEffect, useState } from "react";
import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import "../styles/global.css";

const COLLECTION = "pages"; // 👉 changez si votre collection a un autre nom (ex: "website_pages")

export default function TopPages() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const q = query(collection(db, COLLECTION), orderBy("views", "desc"), limit(5));
        const snap = await getDocs(q);
        const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setItems(rows);
      } catch (e) {
        setErr(e?.message || "Erreur inconnue");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div className="main-container">Chargement…</div>;
  if (err) return (
    <div className="main-container">
      <p style={{color:"#b91c1c"}}>Impossible de charger les pages : {err}</p>
      <p className="muted">
        Vérifiez vos règles Firestore et le nom de la collection <code>{COLLECTION}</code>.  
        Les documents doivent contenir un champ numérique <code>views</code>.
      </p>
    </div>
  );

  return (
    <div className="main-container">
      <div className="row" style={{marginBottom:12}}>
        <h2 style={{margin:0}}>Top 5 pages les plus consultées</h2>
        <span className="muted">{items.length} résultats</span>
      </div>

      <div className="cards">
        {items.map(p => (
          <article key={p.id} className="card">
            <h3 style={{marginTop:0, marginBottom:6}}>{p.title || p.slug || p.id}</h3>
            <p className="muted" style={{marginTop:0}}>
              {p.path ? `/${p.path}` : (p.url || "—")}
            </p>
            <div className="row">
              <div className="muted">Vues</div>
              <strong>{typeof p.views === "number" ? p.views : "0"}</strong>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
